import React from "react";

// Función para detectar si el contenido parece HTML
const isHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const InfoModal = ({ closeModalHandler, content }) => {
  return (
    <>
      <div className="modalContent-dialogBody">
        {isHTML(content) ? (
          // ¡IMPORTANTE! Solo usar `dangerouslySetInnerHTML` si confías en el contenido
          <div
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <p>{content}</p>
        )}
      </div>

      <div className="modalContent-dialogFooter">
        <button
          className="c-button"
          onClick={closeModalHandler}
        >
          Close
        </button>
      </div>
    </>
  );
};

export default InfoModal;
